module.exports = __webpack_public_path__ + "img/image(2)-2.1f2c9654.png";